import Config from "../../config";

export const ValidateRequired = (value) => {
  if (value.length === 0) {
    return "Required";
  }
  return null;
};

export const Validate = (formData, fieldsToValidate) => {
  let errors = {};
  let isValid = true;
  for (const id in fieldsToValidate) {
    const innerParam = formData[id];
    if (Array.isArray(innerParam)) {
      errors[id] = [];
      for (let index = 0; index < innerParam.length; index++) {
        errors[id][index] = {};
        for (const key in fieldsToValidate[id][index]) {
          const validateFunction = fieldsToValidate[id][index][key];
          errors[id][index][key] = validateFunction(innerParam[index][key]);
          if (errors[id][index][key] === null) {
            continue;
          }
          isValid = false;
        }
      }
    } else {
      const validateFunction = fieldsToValidate[id];
      errors[id] = validateFunction(formData[id]);
      if (errors[id] === null) {
        continue;
      }
      isValid = false;
    }
  }
  return [isValid, errors];
};

export const getSelectValidationStyle = (validationErrorsValue) => {
  if (validationErrorsValue === null || validationErrorsValue === "" || validationErrorsValue === undefined) {
    return {};
  }
  return {
    control: (base) => ({
      ...base,
      borderColor: "indianred",
    }),
  };
};

export const validationUseEffectHelper = (id, value, fieldsToValidate, validationErrors, setValidationError) => {
  let valueToCheck = "";
  if (value !== null && value !== undefined) {
    if (typeof value === "object") {
      valueToCheck = value.label;
    } else {
      valueToCheck = value;
    }
  }
  if (!(valueToCheck === "" && !(id in validationErrors)) && id in fieldsToValidate) {
    const error = fieldsToValidate[id](value);
    setValidationError((validationErrors) => ({ ...validationErrors, [id]: error }));
  }
};

export const validateGuid = (inputGuid) => {
  const { redirectUrl } = Config.cognito;
  let regexp = new RegExp(/^[0-9a-fA-F]{8}-([0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12}?$/);
  if (regexp.test(inputGuid)) {
    return JSON.parse(JSON.stringify(inputGuid));
  } else {
    window.location.assign(`${redirectUrl}/not-found`);
  }
};
